(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-mybets-wager/assets/javascripts/api-calls/wager.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-mybets-wager/assets/javascripts/api-calls/wager.js');

'use strict';

const GET = 'GET';
const API_PATHS = svs.isServer ? require('../../../../shared-constants/assets/javascripts/api-paths.es6') : svs.lyckoplatsen.components.shared_constants.API_PATHS;
const logger = svs.isServer ? require('@svenskaspelab/trinidad-core').core.logger('module:lyckoplatsen') : svs.lyckoplatsen.logger;
const jupiter = svs.isServer ? require('@svenskaspelab/trinidad-core').core.jupiter : svs.core.jupiter;
async function fetchWagerById(wagerId, req) {
  try {
    const result = await jupiter.callAsync({
      path: API_PATHS.wagerById(wagerId),
      method: GET,
      req
    });
    return result;
  } catch (error) {
    logger.error("Failed to get data from API at path: ".concat(API_PATHS.wagerById(wagerId)), error);
  }
}
if (svs.isServer) {
  module.exports = {
    fetchWagerById
  };
} else {
  setGlobal('svs.lyckoplatsen.components.shared_mybets_wager.api_calls', {
    fetchWagerById
  });
}

 })(window);